export function isWindowOpen(conversation) {
    const exp = conversation?.window_expires_at;
    if (!exp) return false;
    const t = new Date(exp).getTime();
    return Number.isFinite(t) && t > Date.now();
}
